{
  "version": 1,
  "asset_id": "b2ef0deb-3034-4bb2-937a-e2bc7d63d8ef",
  "project_id": "8cc9b1c1-0457-40cd-aa82-ea9e6032ce50",
  "url": "/__l5e/assets-v1/b2ef0deb-3034-4bb2-937a-e2bc7d63d8ef/karaoke-36.webp",
  "r2_key": "a/v1/8cc9b1c1-0457-40cd-aa82-ea9e6032ce50/b2ef0deb-3034-4bb2-937a-e2bc7d63d8ef/karaoke-36.webp",
  "original_filename": "karaoke-36.webp",
  "size": 149560,
  "content_type": "image/webp",
  "created_at": "2026-10-12T09:40:57Z"
}
